import React from "react";
import { Button, Badge } from "reactstrap";
import { formatModerationMessage } from "utils/formatMessage";

const ReviewDrawer = ({ isOpen, onClose, selectedItem, handleAction, activeTab, isSeniorMod }) => {
    if (!isOpen || !selectedItem) return null;

    return (
        <div className="review-drawer-overlay" onClick={onClose}>
            <div className="review-drawer" onClick={(e) => e.stopPropagation()}>
                <div className="drawer-header">
                    <h4 className="mb-0 text-uppercase font-weight-bold">Content Review</h4>
                    <Button close onClick={onClose} />
                </div>
                <div className="drawer-body">
                    <div className="context-section">
                        <span className="context-label">Original Message</span>
                        <div className="message-box">
                            "{formatModerationMessage(selectedItem.message)}"
                        </div>
                    </div>

                    <div className="context-section">
                        <span className="context-label">Translation (AI Assisted)</span>
                        <div className="translation-box">
                            {selectedItem.translation || "No translation required/available."}
                        </div>
                    </div>

                    <div className="context-section">
                        <span className="context-label">Metadata</span>
                        <div className="d-flex justify-content-between mb-2">
                            <small style={{ color: "#525f7f", fontWeight: 600, fontSize: "13px" }}>Status:</small>
                            <Badge color={selectedItem.status === 'pending' || selectedItem.eh_status === 'pending' ? 'danger' : 'success'}>
                                {selectedItem.status || selectedItem.eh_status || 'pending'}
                            </Badge>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                            <small style={{ color: "#525f7f", fontWeight: 600, fontSize: "13px" }}>Room:</small>
                            <Badge color="info">{selectedItem.room}</Badge>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                            <small style={{ color: "#525f7f", fontWeight: 600, fontSize: "13px" }}>Type:</small>
                            <Badge color="primary">{selectedItem.type}</Badge>
                        </div>
                        {selectedItem.type === "User Report" && (
                            <div className="d-flex justify-content-between mb-2">
                                <small style={{ color: "#525f7f", fontWeight: 600, fontSize: "13px" }}>Reporter:</small>
                                <small style={{ color: "#172b4d", fontWeight: 700, fontSize: "13px" }}>{selectedItem.reporter}</small>
                            </div>
                        )}
                        <div className="d-flex justify-content-between">
                            <small style={{ color: "#525f7f", fontWeight: 600, fontSize: "13px" }}>Time:</small>
                            <small style={{ color: "#172b4d", fontWeight: 700, fontSize: "13px" }}>{new Date(selectedItem.timestamp).toLocaleString()}</small>
                        </div>
                    </div>

                    <div className="context-section">
                        <span className="context-label">User Profile Snippet</span>
                        <div className="user-snippet">
                            <div className="bg-lighter p-2 rounded-circle mr-3">
                                <i className="ni ni-single-02 text-primary" />
                            </div>
                            <div>
                                <h5 className="mb-0">{selectedItem.user}</h5>
                                <small className="text-muted">Username: {selectedItem.handlerName}</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="drawer-footer">
                    <span className="context-label mb-3">Moderation Actions</span>
                    <div className="action-btn-group">
                        <Button block color="success" outline disabled={selectedItem.actionHistory?.includes('approved') || selectedItem.actionHistory?.includes('removed')} onClick={() => handleAction('approved')}>
                            <i className="ni ni-check-bold mr-2" /> {selectedItem.actionHistory?.includes('approved') ? "Message Approved" : "Approve Message"}
                        </Button>
                        <Button block color="danger" outline disabled={selectedItem.actionHistory?.includes('removed') || selectedItem.actionHistory?.includes('approved')} onClick={() => handleAction('removed')}>
                            <i className="ni ni-fat-remove mr-2" /> {selectedItem.actionHistory?.includes('removed') ? "Content Removed" : "Remove Content"}
                        </Button>
                        <Button block color="warning" outline disabled={selectedItem.actionHistory?.includes('warned')} onClick={() => handleAction('warned')}>
                            <i className="ni ni-bell-55 mr-2" /> {selectedItem.actionHistory?.includes('warned') ? "User Warned" : "Warn User"}
                        </Button>
                        {selectedItem.isUserBlocked ? (
                            <Button block color="info" onClick={() => handleAction('unblocked')}>
                                <i className="ni ni-button-play mr-2" /> Unblock User Profile
                            </Button>
                        ) : (
                            <Button block color="danger" onClick={() => handleAction('blocked')}>
                                <i className="ni ni-button-pause mr-2" /> Block User Profile
                            </Button>
                        )}
                        {!isSeniorMod && activeTab !== "escalated" ? (
                            <Button block color="default" outline className="mt-4" disabled={selectedItem.actionHistory?.includes('escalated')} onClick={() => handleAction('escalated')}>
                                <i className="ni ni-bold-up mr-2" /> {selectedItem.actionHistory?.includes('escalated') ? "Escalated to Senior" : "Escalate to Senior Mod"}
                            </Button>
                        ) : isSeniorMod || activeTab === "escalated" ? (
                            <div className="mt-4 pt-3 border-top w-100 text-center">
                                <Badge color="warning" className="text-xs">Senior Resolution Mode</Badge>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReviewDrawer;
